import { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { TranslateButton } from './TranslateButton';
import { cn } from '@/lib/utils';

interface TranslatableFieldLabelProps {
  children: ReactNode;
  htmlFor?: string;
  onTranslate: () => void;
  isTranslating?: boolean;
  disabled?: boolean;
  className?: string;
}

export const TranslatableFieldLabel = ({
  children,
  htmlFor,
  onTranslate,
  isTranslating = false,
  disabled = false,
  className,
}: TranslatableFieldLabelProps) => {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      <Label htmlFor={htmlFor}>{children}</Label>
      <TranslateButton onClick={onTranslate} isTranslating={isTranslating} disabled={disabled} />
    </div>
  );
};
